import loadable from '@loadable/component';

export const MANUAL_SEO_SEARCH = 'manual-seo-search';
export const SEO_SEARCH = 'seo-search';
export const MAIN_SEARCH = 'main-search';

const SeoSearch = loadable(() => import('./SeoSearch'));
const ManualSeoSearch = loadable(() => import('./ManualSeoSearch'));
const MainSeoSearch = loadable(() => import('../../Search'));

export default (templateName) => {
  switch (templateName) {
    case MANUAL_SEO_SEARCH:
      return ManualSeoSearch;
    case SEO_SEARCH:
      return SeoSearch;
    case MAIN_SEARCH:
      return MainSeoSearch;
    default:
      return null;
  }
};
